import { filtersHelper } from '@/utils';

export const productConditionModel = (data = {}) => ({
    uuid: data.uuid,
    name: data.name || '',
    isActive: data.is_active === true || data.is_active === 1 ,
    createdAt: filtersHelper.getDateTimeFormat(data.created_at),
    updatedAt: filtersHelper.getDateTimeFormat(data.updated_at),
    createdBy: data.created_by,
    updatedBy: data.updated_by,
});
